import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["initialState"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useEffect, useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import _get from 'lodash/get';
import { PLAY_STATE, PAUSE_STATE } from './PaginatedPlay.constants';
import { getStateIcon, getOppositeActionHandler, getPaginationPlayEventAction } from './PaginatedPlay.utils';
import { GoogleAnalytics } from '../../../../../../services/analytics';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { PaginationContext } from '../../contexts/pagination';
var defaultProps = {
  initialState: PLAY_STATE
};
export default function PaginationPlay(_ref) {
  var initialState = _ref.initialState,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    currentState = _useState2[0],
    setCurrentState = _useState2[1];
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    event = _useContext.event;
  var autoScrollEnabled = pagination.autoScrollEnabled,
    playAutoScroll = pagination.playAutoScroll,
    pauseAutoScroll = pagination.pauseAutoScroll,
    totalPages = pagination.totalPages;
  var stateIcon = getStateIcon(currentState);
  var actionHandlers = {
    play: playAutoScroll,
    pause: pauseAutoScroll
  };
  var oppositeActionHandler = getOppositeActionHandler(currentState, actionHandlers);
  function handleOppositeAction() {
    oppositeActionHandler();
    var category = _get(event, 'category');
    var action = getPaginationPlayEventAction(currentState);
    GoogleAnalytics.event(category, action);
  }
  useEffect(function () {
    setCurrentState(autoScrollEnabled ? PLAY_STATE : PAUSE_STATE);
  }, [autoScrollEnabled]);
  if (totalPages <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: "pagination-play"
  }, getButtonProps(_objectSpread({}, rest)), {
    icon: true,
    onClick: handleOppositeAction,
    "aria-label": stateIcon
  }), /*#__PURE__*/React.createElement(Icon, {
    name: stateIcon
  }));
}
PaginationPlay.defaultProps = defaultProps;